import { useTranslation } from 'react-i18next';
import ServicesSection from '../components/servicesSection/ServicesSection';
import BenefitsSection from '../components/benefitsSection/BenefitsSection';
import HeroProposal from '../components/heroConcept/heroConcept';
import CtaSection from '../components/ctaSection/CtaSection';
import PageSEO from '../components/PageSEO';
import JsonLd from '../components/seo/JsonLd';
import { buildBaseGraph, buildWebPage } from '../config/schema';

const Home = () => {
  const { t, i18n } = useTranslation('home');
  const lang = i18n.resolvedLanguage || 'en';
  const homeTitle = t('seo.title');

  const skills = t('services.items', { returnObjects: true }).map((item, i) => ({
    title_skill: item.title,
    descriptions: item.descriptions,
    cta: item.cta,
    link: i === 0 ? '/projects' : i === 1 ? '/design' : '/gallery',
  }));

  const graph = [
    ...buildBaseGraph({ lang }),
    buildWebPage({
      path: '/',
      name: homeTitle,
      description: t('header.text'),
      lang,
      // No content-managed hero image exists on Home -- don't invent one.
    }),
  ];

  return (
    <>
      <PageSEO
        title={homeTitle}
        description={t('header.text')}
        path="/"
      />
      <JsonLd graph={graph} />
      <HeroProposal />
      <main>
        <ServicesSection skills={skills} />
        <BenefitsSection />
        <CtaSection />
      </main>
    </>
  );
};

export default Home;